import Button from 'wa-storybook/components/general/button/button';
import styles from './usl-login-form.module.scss';
import classNames from 'classnames';
import { AuthClient } from '@workivate/tho-web-shared';
import { DisasterRecovery } from '../disaster-recovery/disaster-recovery';
import { DisasterRecoveryContext } from 'globals/context/disaster-recovery-context';
import ComponentAnimation, {
  AnimationTypes,
} from 'wa-storybook/components/general/component-animation/component-animation';

// Temporary button until we have designs for the new login page
export const LoginFormUSL = () => {
  const isInDisasterRecoveryMode = React.useContext(DisasterRecoveryContext);

  const handleButtonClick = async () => {
    await AuthClient.registerAndAuthorize('web');
  };

  return (
    <div className={styles.container}>
      <div className={styles['content--login']}>
        <h1 className={classNames(styles.title, styles['title--login'])}>
          {polyglot.t('login.section_title')}
        </h1>

        <Button
          dataHook='usl-login-button'
          onClick={handleButtonClick}
          text={polyglot.t(`login.action`)}
        />
        {isInDisasterRecoveryMode && (
          <>
            <ComponentAnimation
              type={AnimationTypes.EXPAND_DOWN_AND_FADE_IN}
              id='login-error-mesage'
            >
              <div role='alert' className={styles.error}>
                {polyglot.t('api_errors.something_wrong')}
              </div>
            </ComponentAnimation>

            <div className={styles['recovery-container']}>
              <DisasterRecovery />
            </div>
          </>
        )}
      </div>
    </div>
  );
};
